export default "/images/map-marker.svg?0ec15805954c87cd046ed169e91b5b1b";